<template>
<div>
    <div class="form-row">
        <div class="col-8">
            <form-input label="Provider Name" v-model="formData.provider_name" :errors="errors.provider_name" type="text" :maxlength="255" />
        </div>

        <div class="col-4">
            <form-input label="Plan Type" v-model="formData.plan_type" :errors="errors.plan_type" type="select" :options="planTypeOptions" />
        </div>
    </div>

    <div class="form-row" v-if="showPlanNumber">
        <div class="col-8">
            <form-input label="Plan Number" v-model="formData.plan_number" :errors="errors.plan_number" type="text" :maxlength="48" />
        </div>
    </div>

    <div class="form-row">
        <div class="col-6">
            <form-input
                label="Plan Starts On"
                v-model="formData.starts_on"
                :errors="errors.starts_on"
                type="date"
                helper-text="The plan runs from this date until it is stopped."
            />
        </div>
    </div>

    <div class="form-row">
        <div class="col">
            <form-input label="Money Manager" v-model="formData.money_manager" :errors="errors.money_manager" type="select" :options="moneyManagerOptions" />
        </div>
    </div>

    <p v-if="formData.money_manager == 'paymasters'">
        Deposit funds to:
    </p>

    <div class="form-row" v-if="formData.money_manager == 'paymasters'">
        <div class="col">
            <form-input
                label="ACH Routing Number"
                v-model="formData.routing_number"
                :errors="errors.routing_number"
                type="integer-string"
                maxlength="9"
                extraclasses=""
                @update:model-value="onUpdateRoutingNumber()"
                :helperHtml="bankNameHtml"
                :popoverHelperHtml="'<p>Your bank&rsquo;s Routing Number is the first set of numbers on the bottom of your check. It is 9 digits long.</p>'"
            />

        </div>

        <div class="col">
            <form-input
                label="Account Number"
                v-model="formData.account_number"
                :errors="errors.account_number"
                type="integer-string"
                maxlength="17"
                :popoverHelperHtml="'<p>Your Account Number is the second set of numbers on the bottom of your check. It can vary in length.</p>'"
            />

            <p v-if="formData.account_number_last_4"><small>Leave blank if you do not wish to update it.</small></p>
        </div>
    </div>

    <form-errors :errors="formErrors" />
</div>
</template>

<script>
import FormMixin from '@/mixins/Form'

export default {
    props: ['initialValue', 'showPlanNumber', ],
    mixins: [FormMixin, ],
    computed: {
        planTypeOptions() {
            return [
                {text: '401(k)', value: '401k'},
                {text: 'Roth 401(k)', value: 'roth-401k'},
                {text: '403(b)', value: '403b'},
                {text: 'Roth 403(b)', value: 'roth-403b'},
                {text: '408(p) SIMPLE IRA', value: 'simple-ira'},
            ]
        },
        moneyManagerOptions() {
            return [
                {text: 'Paymasters', value: 'paymasters'},
                {text: 'Company', value: 'company'},
            ]
        },
        bankNameHtml() {
            if (!this.bankName) {
                return ''
            }

            return '<i class="fas fa-fw fa-check mr-hf text-primary" aria-hidden="true"></i> ' + this.bankName
        },
    },
    data() {
        return {
            bankName: '',
            bankNames: {},
            formData: this.makeFormData(),
            formRules: {
                provider_name: {presence: {allowEmpty: false}, },
                plan_type: {presence: {allowEmpty: false}, },
                plan_number: this.showPlanNumber ? {presence: {allowEmpty: false}, } : null,
                starts_on: {presence: {allowEmpty: false}, date: true},
                money_manager: {presence: {allowEmpty: false}, },
            },
            formLabels: {
            },
        }
    },
    methods: {
        makeFormData() {
            return {
                plan_type: this.initialValue.plan_type ? this.initialValue.plan_type : '',
                provider_name: this.initialValue.provider_name ? this.initialValue.provider_name : '',
                plan_number: this.initialValue.plan_number ? this.initialValue.plan_number : '',
                starts_on: this.initialValue.starts_on ? this.initialValue.starts_on : '',
                money_manager: this.initialValue.money_manager ? this.initialValue.money_manager : '',
                routing_number: this.initialValue.routing_number ? this.initialValue.routing_number : '',
                account_number: this.initialValue.account_number ? this.initialValue.account_number : '',
                account_number_last_4: this.initialValue.account_number_last_4 ? this.initialValue.account_number_last_4 : '',
            }
        },
        setErrors(errors) {
            Object.assign(this.errors, errors)
        },
        getFormRules() {
            const rules = JSON.parse(JSON.stringify(this.formRules))

            if (this.formData.money_manager == 'paymasters') {
                rules.routing_number = {presence: {allowEmpty: false}, }
                if (!this.showPlanNumber) {
                    rules.account_number = {presence: {allowEmpty: false}, }
                }
            }

            return rules
        },
        onUpdateRoutingNumber() {
            this.errors.routing_number = []

            const routingNumber = this.formData.routing_number
            if (!routingNumber) {
                this.bankName = ''
                return
            }

            // only ask the API to validate if it looks like a valid-looking number
            if (routingNumber.length != 9) {
                this.bankName = ''
                return
            }

            if (this.bankNames.hasOwnProperty(routingNumber)) {
                this.bankName = this.bankNames[routingNumber]
                return
            }

            this.$api.post('/validate/brn', {'routing_number': routingNumber}).then((resp) => {
                this.bankName = resp['bank_name']
                this.bankNames[routingNumber] = resp['bank_name']
            }).catch((errors) => {
                this.errors.routing_number = errors['routing_number']
                this.bankName = ''
            })
        },
        validate() {
            this.errors = {}
            this.formErrors = []
            const originalValidate = FormMixin.methods.validate.bind(this)
            let isValid = originalValidate()

            if ((this.formData.money_manager == 'paymasters') && !this.bankName) {
                isValid = false
                this.errors.routing_number = ['Routing number not found.']
            }

            return isValid
        },
    },
}

</script>
